import { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import WebsiteProjectPage from '@99designs/acquisition-frontend/acquisition/components/WebsiteProjectPage';
import { SiteContext } from '@99designs/acquisition-frontend/shared/lib/site';
import { Site } from '@99designs/site-navigation/lib/Site';
import DefaultPageLayout from '../components/common/DefaultPageLayout';
import { getDefaultPageProps } from '../lib/getDefaultPageProps';
import type { SiteConfig } from '@99designs/site-navigation/lib/Site';

export default function WebsiteBuildersPage({
    siteConfig,
    currentPath,
    userRole,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
    const site = new Site(JSON.parse(siteConfig) as SiteConfig);

    return (
        <DefaultPageLayout role={userRole} site={site}>
            <SiteContext.Provider value={site}>
                <WebsiteProjectPage currentPath={currentPath} site={site} />
            </SiteContext.Provider>
        </DefaultPageLayout>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    const defaultProps = await getDefaultPageProps(context);

    return {
        props: {
            ...defaultProps,
            currentPath: '/website-builders',
        },
    };
};
